import React from "react"

const Loader = (props) => {
  return (
    <div className="spinner">
      <div className="loader" />
    </div>
  )
}

export default Loader
